import { COUNTRY_CODES } from "$routes/_lib/constants";
import { prop, sortBy } from "ramda";
import React from "react";
import { defineMessage, useIntl } from "react-intl";

const countryMap = {
  [COUNTRY_CODES.KENYA]: defineMessage({
    id: "country.kenya",
    defaultMessage: "Kenya",
  }),
  [COUNTRY_CODES.LEBANON]: defineMessage({
    id: "country.lebanon",
    defaultMessage: "Lebanon",
  }),
  [COUNTRY_CODES.GHANA]: defineMessage({
    id: "country.ghana",
    defaultMessage: "Ghana",
  }),
  [COUNTRY_CODES.NIGERIA]: defineMessage({
    id: "country.nigeria",
    defaultMessage: "Nigeria",
  }),
  [COUNTRY_CODES.IRAQ]: defineMessage({
    id: "country.iraq",
    defaultMessage: "Iraq",
  }),
  [COUNTRY_CODES.SOMALIA]: defineMessage({
    id: "country.somalia",
    defaultMessage: "Somalia",
  }),
  [COUNTRY_CODES.SYRIA]: defineMessage({
    id: "country.syria",
    defaultMessage: "Syrian Arab Republic",
  }),
  [COUNTRY_CODES.UK]: defineMessage({
    id: "country.uk",
    defaultMessage: "United Kingdom",
  }),
  [COUNTRY_CODES.AFGHANISTAN]: defineMessage({
    id: "country.afghanistan",
    defaultMessage: "Afghanistan",
  }),
  [COUNTRY_CODES.ÅLAND_ISLANDS]: defineMessage({
    id: "country.alan_islands",
    defaultMessage: "Åland Islands",
  }),
  [COUNTRY_CODES.ALBANIA]: defineMessage({
    id: "country.albania",
    defaultMessage: "Albania",
  }),
  [COUNTRY_CODES.ALGERIA]: defineMessage({
    id: "country.algeria",
    defaultMessage: "Algeria",
  }),
  [COUNTRY_CODES.AMERICAN_SAMOA]: defineMessage({
    id: "country.americanSamoa",
    defaultMessage: "American Samoa",
  }),
  [COUNTRY_CODES.ANDORRA]: defineMessage({
    id: "country.andorra",
    defaultMessage: "Andorra",
  }),
  [COUNTRY_CODES.ANGOLA]: defineMessage({
    id: "country.angola",
    defaultMessage: "Angola",
  }),
  [COUNTRY_CODES.ANGUILLA]: defineMessage({
    id: "country.anguilla",
    defaultMessage: "Anguilla",
  }),
  [COUNTRY_CODES.ANTARCTICA]: defineMessage({
    id: "country.antarctica",
    defaultMessage: "Antarctica",
  }),
  [COUNTRY_CODES.ANTIGUA_AND_BARBUDA]: defineMessage({
    id: "country.antiguaBarbuda",
    defaultMessage: "Antigua and Barbuda",
  }),
  [COUNTRY_CODES.ARGENTINA]: defineMessage({
    id: "country.argentina",
    defaultMessage: "Argentina",
  }),
  [COUNTRY_CODES.ARMENIA]: defineMessage({
    id: "country.armenia",
    defaultMessage: "Armenia",
  }),
  [COUNTRY_CODES.ARUBA]: defineMessage({
    id: "country.aruba",
    defaultMessage: "Aruba",
  }),
  [COUNTRY_CODES.AUSTRALIA]: defineMessage({
    id: "country.autralia",
    defaultMessage: "Australia",
  }),
  [COUNTRY_CODES.AUSTRIA]: defineMessage({
    id: "country.austria",
    defaultMessage: "Austria",
  }),
  [COUNTRY_CODES.AZERBAIJAN]: defineMessage({
    id: "country.azerbaijan",
    defaultMessage: "Azerbaijan",
  }),
  [COUNTRY_CODES.BAHAMAS]: defineMessage({
    id: "country.bahamas",
    defaultMessage: "Bahamas",
  }),
  [COUNTRY_CODES.BAHRAIN]: defineMessage({
    id: "country.bahrain",
    defaultMessage: "Bahrain",
  }),
  [COUNTRY_CODES.BANGLADESH]: defineMessage({
    id: "country.bangladesh",
    defaultMessage: "Bangladesh",
  }),
  [COUNTRY_CODES.BARBADOS]: defineMessage({
    id: "country.barbados",
    defaultMessage: "Barbados",
  }),
  [COUNTRY_CODES.BELARUS]: defineMessage({
    id: "country.belarus",
    defaultMessage: "Belarus",
  }),
  [COUNTRY_CODES.BELGIUM]: defineMessage({
    id: "country.belgium",
    defaultMessage: "Belgium",
  }),
  [COUNTRY_CODES.BELIZE]: defineMessage({
    id: "country.belize",
    defaultMessage: "Belize",
  }),
  [COUNTRY_CODES.BENIN]: defineMessage({
    id: "country.benin",
    defaultMessage: "Benin",
  }),
  [COUNTRY_CODES.BERMUDA]: defineMessage({
    id: "country.bermuda",
    defaultMessage: "Bermuda",
  }),
  [COUNTRY_CODES.BHUTAN]: defineMessage({
    id: "country.bhutan",
    defaultMessage: "Bhutan",
  }),
  [COUNTRY_CODES.BOLIVIA]: defineMessage({
    id: "country.bolivia",
    defaultMessage: "Bolivia",
  }),
  [COUNTRY_CODES.BOSNIA_AND_HERZEGOVINA]: defineMessage({
    id: "country.bosniaHerzegovina",
    defaultMessage: "Bosnia and Herzegovina",
  }),
  [COUNTRY_CODES.BOTSWANA]: defineMessage({
    id: "country.botswana",
    defaultMessage: "Botswana",
  }),
  [COUNTRY_CODES.BOUVET_ISLAND]: defineMessage({
    id: "country.bouvetIsland",
    defaultMessage: "Bouvet Island",
  }),
  [COUNTRY_CODES.BRAZIL]: defineMessage({
    id: "country.brazil",
    defaultMessage: "Brazil",
  }),
  [COUNTRY_CODES.BRITISH_INDIAN_OCEAN_TERRITORY]: defineMessage({
    id: "country.britishIndianOceanTer",
    defaultMessage: "British Indian Ocean Territory",
  }),
  [COUNTRY_CODES.BRUNEI_DARUSSALAM]: defineMessage({
    id: "country.bruneiDarussalam",
    defaultMessage: "Brunei Darussalam",
  }),
  [COUNTRY_CODES.BULGARIA]: defineMessage({
    id: "country.bulgaria",
    defaultMessage: "Bulgaria",
  }),
  [COUNTRY_CODES.BURKINA_FASO]: defineMessage({
    id: "country.burkinaFaso",
    defaultMessage: "Burkina Faso",
  }),
  [COUNTRY_CODES.BURUNDI]: defineMessage({
    id: "country.burundi",
    defaultMessage: "Burundi",
  }),
  [COUNTRY_CODES.CAMBODIA]: defineMessage({
    id: "country.cambodia",
    defaultMessage: "Cambodia",
  }),
  [COUNTRY_CODES.CAMEROON]: defineMessage({
    id: "country.cameroon",
    defaultMessage: "Cameroon",
  }),
  [COUNTRY_CODES.CANADA]: defineMessage({
    id: "country.canada",
    defaultMessage: "Canada",
  }),
  [COUNTRY_CODES.CAPE_VERDE]: defineMessage({
    id: "country.capeVerde",
    defaultMessage: "Cape Verde",
  }),
  [COUNTRY_CODES.CAYMAN_ISLANDS]: defineMessage({
    id: "country.caymanIslands",
    defaultMessage: "Cayman Islands",
  }),
  [COUNTRY_CODES.CENTRAL_AFRICAN_REPUBLIC]: defineMessage({
    id: "country.centralAfricanRepublic",
    defaultMessage: "Central African Republic",
  }),
  [COUNTRY_CODES.CHAD]: defineMessage({
    id: "country.chad",
    defaultMessage: "Chad",
  }),
  [COUNTRY_CODES.CHILE]: defineMessage({
    id: "country.chile",
    defaultMessage: "Chile",
  }),
  [COUNTRY_CODES.CHINA]: defineMessage({
    id: "country.china",
    defaultMessage: "China",
  }),
  [COUNTRY_CODES.CHRISTMAS_ISLAND]: defineMessage({
    id: "country.christmasIsland",
    defaultMessage: "Christmas Island",
  }),
  [COUNTRY_CODES.COCOS_ISLANDS]: defineMessage({
    id: "country.cocosIslands",
    defaultMessage: "Cocos (Keeling) Islands",
  }),
  [COUNTRY_CODES.COLOMBIA]: defineMessage({
    id: "country.colombia",
    defaultMessage: "Colombia",
  }),
  [COUNTRY_CODES.COMOROS]: defineMessage({
    id: "country.comoros",
    defaultMessage: "Comoros",
  }),
  [COUNTRY_CODES.CONGO]: defineMessage({
    id: "country.congo",
    defaultMessage: "Congo",
  }),
  [COUNTRY_CODES.THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO]: defineMessage({
    id: "country.congoDemocratic",
    defaultMessage: "Congo, The Democratic Republic of the",
  }),
  [COUNTRY_CODES.COOK_ISLANDS]: defineMessage({
    id: "country.cookIslands",
    defaultMessage: "Cook Islands",
  }),
  [COUNTRY_CODES.COSTA_RICA]: defineMessage({
    id: "country.costaRica",
    defaultMessage: "Costa Rica",
  }),
  [COUNTRY_CODES.COTE_D_IVOIRE]: defineMessage({
    id: "country.coteDIvoire",
    defaultMessage: "Cote D'Ivoire",
  }),
  [COUNTRY_CODES.CROATIA]: defineMessage({
    id: "country.croatia",
    defaultMessage: "Croatia",
  }),
  [COUNTRY_CODES.CUBA]: defineMessage({
    id: "country.cuba",
    defaultMessage: "Cuba",
  }),
  [COUNTRY_CODES.CYPRUS]: defineMessage({
    id: "country.cyprus",
    defaultMessage: "Cyprus",
  }),
  [COUNTRY_CODES.CZECH_REPUBLIC]: defineMessage({
    id: "country.czechRepublic",
    defaultMessage: "Czech Republic",
  }),
  [COUNTRY_CODES.DENMARK]: defineMessage({
    id: "country.denmark",
    defaultMessage: "Denmark",
  }),
  [COUNTRY_CODES.DJIBOUTI]: defineMessage({
    id: "country.djibouti",
    defaultMessage: "Djibouti",
  }),
  [COUNTRY_CODES.DOMINICA]: defineMessage({
    id: "country.dominica",
    defaultMessage: "Dominica",
  }),
  [COUNTRY_CODES.DOMINICAN_REPUBLIC]: defineMessage({
    id: "country.dominicanRepublic",
    defaultMessage: "Dominican Republic",
  }),
  [COUNTRY_CODES.ECUADOR]: defineMessage({
    id: "country.ecuador",
    defaultMessage: "Ecuador",
  }),
  [COUNTRY_CODES.EGYPT]: defineMessage({
    id: "country.egypt",
    defaultMessage: "Egypt",
  }),
  [COUNTRY_CODES.EL_SALVADOR]: defineMessage({
    id: "country.elSalvador",
    defaultMessage: "El Salvador",
  }),
  [COUNTRY_CODES.EQUATORIAL_GUINEA]: defineMessage({
    id: "country.equatorialGuinea",
    defaultMessage: "Equatorial Guinea",
  }),
  [COUNTRY_CODES.ERITREA]: defineMessage({
    id: "country.eritrea",
    defaultMessage: "Eritrea",
  }),
  [COUNTRY_CODES.ESTONIA]: defineMessage({
    id: "country.estonia",
    defaultMessage: "Estonia",
  }),
  [COUNTRY_CODES.ETHIOPIA]: defineMessage({
    id: "country.ethiopia",
    defaultMessage: "Ethiopia",
  }),
  [COUNTRY_CODES.FALKLAND_ISLANDS]: defineMessage({
    id: "country.falklandIslands",
    defaultMessage: "Falkland Islands (Malvinas)",
  }),
  [COUNTRY_CODES.FAROE_ISLANDS]: defineMessage({
    id: "country.faroeIslands",
    defaultMessage: "Faroe Islands",
  }),
  [COUNTRY_CODES.FIJI]: defineMessage({
    id: "country.fiji",
    defaultMessage: "Fiji",
  }),
  [COUNTRY_CODES.FINLAND]: defineMessage({
    id: "country.finland",
    defaultMessage: "Finland",
  }),
  [COUNTRY_CODES.FRANCE]: defineMessage({
    id: "country.france",
    defaultMessage: "France",
  }),
  [COUNTRY_CODES.FRENCH_GUIANA]: defineMessage({
    id: "country.frenchGuiana",
    defaultMessage: "French Guiana",
  }),
  [COUNTRY_CODES.FRENCH_POLYNESIA]: defineMessage({
    id: "country.frenchPolynesia",
    defaultMessage: "French Polynesia",
  }),
  [COUNTRY_CODES.FRENCH_SOUTHERN_TERRITORIES]: defineMessage({
    id: "country.frenchSouthernTerritories",
    defaultMessage: "French Southern Territories",
  }),
  [COUNTRY_CODES.GABON]: defineMessage({
    id: "country.gabon",
    defaultMessage: "Gabon",
  }),
  [COUNTRY_CODES.GAMBIA]: defineMessage({
    id: "country.gambia",
    defaultMessage: "Gambia",
  }),
  [COUNTRY_CODES.GEORGIA]: defineMessage({
    id: "country.georgia",
    defaultMessage: "Georgia",
  }),
  [COUNTRY_CODES.GERMANY]: defineMessage({
    id: "country.germany",
    defaultMessage: "Germany",
  }),
  [COUNTRY_CODES.GIBRALTAR]: defineMessage({
    id: "country.gibraltar",
    defaultMessage: "Gibraltar",
  }),
  [COUNTRY_CODES.GREECE]: defineMessage({
    id: "country.greece",
    defaultMessage: "Greece",
  }),
  [COUNTRY_CODES.GREENLAND]: defineMessage({
    id: "country.greenland",
    defaultMessage: "Greenland",
  }),
  [COUNTRY_CODES.GRENADA]: defineMessage({
    id: "country.grenada",
    defaultMessage: "Grenada",
  }),
  [COUNTRY_CODES.GUADELOUPE]: defineMessage({
    id: "country.guadeloupe",
    defaultMessage: "Guadeloupe",
  }),
  [COUNTRY_CODES.GUAM]: defineMessage({
    id: "country.guam",
    defaultMessage: "Guam",
  }),
  [COUNTRY_CODES.GUATEMALA]: defineMessage({
    id: "country.guatemala",
    defaultMessage: "Guatemala",
  }),
  [COUNTRY_CODES.GUERNSEY]: defineMessage({
    id: "country.guernsey",
    defaultMessage: "Guernsey",
  }),
  [COUNTRY_CODES.GUINEA]: defineMessage({
    id: "country.guinea",
    defaultMessage: "Guinea",
  }),
  [COUNTRY_CODES.GUINEA_BISSAU]: defineMessage({
    id: "country.guineaBissau",
    defaultMessage: "Guinea-Bissau",
  }),
  [COUNTRY_CODES.GUYANA]: defineMessage({
    id: "country.guyana",
    defaultMessage: "Guyana",
  }),
  [COUNTRY_CODES.HAITI]: defineMessage({
    id: "country.haiti",
    defaultMessage: "Haiti",
  }),
  [COUNTRY_CODES.HEARD_ISLAND_AND_MCDONALD_ISLANDS]: defineMessage({
    id: "country.mcdonald",
    defaultMessage: "Heard Island and Mcdonald Islands",
  }),
  [COUNTRY_CODES.HOLY_SEE]: defineMessage({
    id: "country.vatican",
    defaultMessage: "Holy See (Vatican City State)",
  }),
  [COUNTRY_CODES.HONDURAS]: defineMessage({
    id: "country.honduras",
    defaultMessage: "Honduras",
  }),
  [COUNTRY_CODES.HONG_KONG]: defineMessage({
    id: "country.hongKong",
    defaultMessage: "Hong Kong",
  }),
  [COUNTRY_CODES.HUNGARY]: defineMessage({
    id: "country.hungary",
    defaultMessage: "Hungary",
  }),
  [COUNTRY_CODES.ICELAND]: defineMessage({
    id: "country.iceland",
    defaultMessage: "Iceland",
  }),
  [COUNTRY_CODES.INDIA]: defineMessage({
    id: "country.india",
    defaultMessage: "India",
  }),
  [COUNTRY_CODES.INDONESIA]: defineMessage({
    id: "country.indonesia",
    defaultMessage: "Indonesia",
  }),
  [COUNTRY_CODES.IRELAND]: defineMessage({
    id: "country.ireland",
    defaultMessage: "Ireland",
  }),
  [COUNTRY_CODES.ISLE_OF_MAN]: defineMessage({
    id: "country.isleofMan",
    defaultMessage: "Isle of Man",
  }),
  [COUNTRY_CODES.ISRAEL]: defineMessage({
    id: "country.israel",
    defaultMessage: "Israel",
  }),
  [COUNTRY_CODES.ITALY]: defineMessage({
    id: "country.italy",
    defaultMessage: "Italy",
  }),
  [COUNTRY_CODES.JAMAICA]: defineMessage({
    id: "country.jamaica",
    defaultMessage: "Jamaica",
  }),
  [COUNTRY_CODES.JAPAN]: defineMessage({
    id: "country.japan",
    defaultMessage: "Japan",
  }),
  [COUNTRY_CODES.JERSEY]: defineMessage({
    id: "country.jersey",
    defaultMessage: "Jersey",
  }),
  [COUNTRY_CODES.JORDAN]: defineMessage({
    id: "country.jordan",
    defaultMessage: "Jordan",
  }),
  [COUNTRY_CODES.KAZAKHSTAN]: defineMessage({
    id: "country.kazakhstan",
    defaultMessage: "Kazakhstan",
  }),
  [COUNTRY_CODES.KIRIBATI]: defineMessage({
    id: "country.kiribati",
    defaultMessage: "Kiribati",
  }),
  [COUNTRY_CODES.NORTH_KOREA]: defineMessage({
    id: "country.northKorea",
    defaultMessage: "Korea, Democratic People'S Republic of",
  }),
  [COUNTRY_CODES.KOREA]: defineMessage({
    id: "country.korea",
    defaultMessage: "Korea, Republic of",
  }),
  [COUNTRY_CODES.KUWAIT]: defineMessage({
    id: "country.kuwait",
    defaultMessage: "Kuwait",
  }),
  [COUNTRY_CODES.KYRGYZSTAN]: defineMessage({
    id: "country.kyrgyzstan",
    defaultMessage: "Kyrgyzstan",
  }),
  [COUNTRY_CODES.LAO]: defineMessage({
    id: "country.lao",
    defaultMessage: "Lao People'S Democratic Republic",
  }),
  [COUNTRY_CODES.LATVIA]: defineMessage({
    id: "country.latvia",
    defaultMessage: "Latvia",
  }),
  [COUNTRY_CODES.LESOTHO]: defineMessage({
    id: "country.lesotho",
    defaultMessage: "Lesotho",
  }),
  [COUNTRY_CODES.LIBERIA]: defineMessage({
    id: "country.liberia",
    defaultMessage: "Liberia",
  }),
  [COUNTRY_CODES.LIBYA]: defineMessage({
    id: "country.libyan",
    defaultMessage: "Libyan Arab Jamahiriya",
  }),
  [COUNTRY_CODES.LIECHTENSTEIN]: defineMessage({
    id: "country.liechtenstein",
    defaultMessage: "Liechtenstein",
  }),
  [COUNTRY_CODES.LITHUANIA]: defineMessage({
    id: "country.lithuania",
    defaultMessage: "Lithuania",
  }),
  [COUNTRY_CODES.LUXEMBOURG]: defineMessage({
    id: "country.luxembourg",
    defaultMessage: "Luxembourg",
  }),
  [COUNTRY_CODES.MACAO]: defineMessage({
    id: "country.macao",
    defaultMessage: "Macao",
  }),
  [COUNTRY_CODES.MACEDONIA]: defineMessage({
    id: "country.macedonia",
    defaultMessage: "Macedonia",
  }),
  [COUNTRY_CODES.MADAGASCAR]: defineMessage({
    id: "country.madagascar",
    defaultMessage: "Madagascar",
  }),
  [COUNTRY_CODES.MALAWI]: defineMessage({
    id: "country.malawi",
    defaultMessage: "Malawi",
  }),
  [COUNTRY_CODES.MALAYSIA]: defineMessage({
    id: "country.malaysia",
    defaultMessage: "Malaysia",
  }),
  [COUNTRY_CODES.MALDIVES]: defineMessage({
    id: "country.maldives",
    defaultMessage: "Maldives",
  }),
  [COUNTRY_CODES.MALI]: defineMessage({
    id: "country.mali",
    defaultMessage: "Mali",
  }),
  [COUNTRY_CODES.MALTA]: defineMessage({
    id: "country.malta",
    defaultMessage: "Malta",
  }),
  [COUNTRY_CODES.MARSHALL_ISLANDS]: defineMessage({
    id: "country.marshallIslands",
    defaultMessage: "Marshall Islands",
  }),
  [COUNTRY_CODES.MARTINIQUE]: defineMessage({
    id: "country.martinique",
    defaultMessage: "Martinique",
  }),
  [COUNTRY_CODES.MAURITANIA]: defineMessage({
    id: "country.mauritania",
    defaultMessage: "Mauritania",
  }),
  [COUNTRY_CODES.MAURITIUS]: defineMessage({
    id: "country.mauritius",
    defaultMessage: "Mauritius",
  }),
  [COUNTRY_CODES.MAYOTTE]: defineMessage({
    id: "country.mayotte",
    defaultMessage: "Mayotte",
  }),
  [COUNTRY_CODES.MEXICO]: defineMessage({
    id: "country.mexico",
    defaultMessage: "Mexico",
  }),
  [COUNTRY_CODES.MICRONESIA]: defineMessage({
    id: "country.micronesia",
    defaultMessage: "Micronesia, Federated States of",
  }),
  [COUNTRY_CODES.MOLDOVA]: defineMessage({
    id: "country.moldova",
    defaultMessage: "Moldova",
  }),
  [COUNTRY_CODES.MONACO]: defineMessage({
    id: "country.monaco",
    defaultMessage: "Monaco",
  }),
  [COUNTRY_CODES.MONGOLIA]: defineMessage({
    id: "country.mongolia",
    defaultMessage: "Mongolia",
  }),
  [COUNTRY_CODES.MONTSERRAT]: defineMessage({
    id: "country.montserrat",
    defaultMessage: "Montserrat",
  }),
  [COUNTRY_CODES.MOROCCO]: defineMessage({
    id: "country.morocco",
    defaultMessage: "Morocco",
  }),
  [COUNTRY_CODES.MOZAMBIQUE]: defineMessage({
    id: "country.mozambique",
    defaultMessage: "Mozambique",
  }),
  [COUNTRY_CODES.MYANMAR]: defineMessage({
    id: "country.myanmar",
    defaultMessage: "Myanmar",
  }),
  [COUNTRY_CODES.NAMIBIA]: defineMessage({
    id: "country.namibia",
    defaultMessage: "Namibia",
  }),
  [COUNTRY_CODES.NAURU]: defineMessage({
    id: "country.nauru",
    defaultMessage: "Nauru",
  }),
  [COUNTRY_CODES.NEPAL]: defineMessage({
    id: "country.nepal",
    defaultMessage: "Nepal",
  }),
  [COUNTRY_CODES.NETHERLANDS]: defineMessage({
    id: "country.netherlands",
    defaultMessage: "Netherlands",
  }),
  [COUNTRY_CODES.NETHERLANDS_ANTILLES]: defineMessage({
    id: "country.netherlandsAntilles",
    defaultMessage: "Netherlands Antilles",
  }),
  [COUNTRY_CODES.NEW_CALEDONIA]: defineMessage({
    id: "country.newCaledonia",
    defaultMessage: "New Caledonia",
  }),
  [COUNTRY_CODES.NEW_ZEALAND]: defineMessage({
    id: "country.newZealand",
    defaultMessage: "New Zealand",
  }),
  [COUNTRY_CODES.NICARAGUA]: defineMessage({
    id: "country.nicaragua",
    defaultMessage: "Nicaragua",
  }),
  [COUNTRY_CODES.NIGER]: defineMessage({
    id: "country.niger",
    defaultMessage: "Niger",
  }),
  [COUNTRY_CODES.NIUE]: defineMessage({
    id: "country.niue",
    defaultMessage: "Niue",
  }),
  [COUNTRY_CODES.NORFOLK_ISLAND]: defineMessage({
    id: "country.norfolkIsland",
    defaultMessage: "Norfolk Island",
  }),
  [COUNTRY_CODES.NORTHERN_MARIANA_ISLANDS]: defineMessage({
    id: "country.northernMarianaIslands",
    defaultMessage: "Northern Mariana Islands",
  }),
  [COUNTRY_CODES.NORWAY]: defineMessage({
    id: "country.norway",
    defaultMessage: "Norway",
  }),
  [COUNTRY_CODES.OMAN]: defineMessage({
    id: "country.oman",
    defaultMessage: "Oman",
  }),
  [COUNTRY_CODES.PAKISTAN]: defineMessage({
    id: "country.pakistan",
    defaultMessage: "Pakistan",
  }),
  [COUNTRY_CODES.PALAU]: defineMessage({
    id: "country.palau",
    defaultMessage: "Palau",
  }),
  [COUNTRY_CODES.PALESTINE]: defineMessage({
    id: "country.palestine",
    defaultMessage: "Palestine",
  }),
  [COUNTRY_CODES.PANAMA]: defineMessage({
    id: "country.panama",
    defaultMessage: "Panama",
  }),
  [COUNTRY_CODES.PAPUA_NEW_GUINEA]: defineMessage({
    id: "country.papuaNewGuinea",
    defaultMessage: "Papua New Guinea",
  }),
  [COUNTRY_CODES.PARAGUAY]: defineMessage({
    id: "country.paraguay",
    defaultMessage: "Paraguay",
  }),
  [COUNTRY_CODES.PERU]: defineMessage({
    id: "country.peru",
    defaultMessage: "Peru",
  }),
  [COUNTRY_CODES.PHILIPPINES]: defineMessage({
    id: "country.philippines",
    defaultMessage: "Philippines",
  }),
  [COUNTRY_CODES.PITCAIRN]: defineMessage({
    id: "country.pitcairn",
    defaultMessage: "Pitcairn",
  }),
  [COUNTRY_CODES.POLAND]: defineMessage({
    id: "country.poland",
    defaultMessage: "Poland",
  }),
  [COUNTRY_CODES.PORTUGAL]: defineMessage({
    id: "country.portugal",
    defaultMessage: "Portugal",
  }),
  [COUNTRY_CODES.PUERTO_RICO]: defineMessage({
    id: "country.puertoRico",
    defaultMessage: "Puerto Rico",
  }),
  [COUNTRY_CODES.QATAR]: defineMessage({
    id: "country.qatar",
    defaultMessage: "Qatar",
  }),
  [COUNTRY_CODES.REUNION]: defineMessage({
    id: "country.reunion",
    defaultMessage: "Reunion",
  }),
  [COUNTRY_CODES.ROMANIA]: defineMessage({
    id: "country.romania",
    defaultMessage: "Romania",
  }),
  [COUNTRY_CODES.RUSSIA]: defineMessage({
    id: "country.russia",
    defaultMessage: "Russian Federation",
  }),
  [COUNTRY_CODES.RWANDA]: defineMessage({
    id: "country.rwanda",
    defaultMessage: "RWANDA",
  }),
  [COUNTRY_CODES.SAINT_HELENA]: defineMessage({
    id: "country.saintHelena",
    defaultMessage: "Saint Helena",
  }),
  [COUNTRY_CODES.SAINT_KITTS_AND_NEVIS]: defineMessage({
    id: "country.saintKittsAndNevis",
    defaultMessage: "Saint Kitts and Nevis",
  }),
  [COUNTRY_CODES.SAINT_LUCIA]: defineMessage({
    id: "country.saintLucia",
    defaultMessage: "Saint Lucia",
  }),
  [COUNTRY_CODES.SAINT_PIERRE_AND_MIQUELON]: defineMessage({
    id: "country.saintPierreAndMiquelo",
    defaultMessage: "Saint Pierre and Miquelon",
  }),
  [COUNTRY_CODES.SAINT_VINCENT_AND_THE_GRENADINES]: defineMessage({
    id: "country.saintVincent",
    defaultMessage: "Saint Vincent and the Grenadines",
  }),
  [COUNTRY_CODES.SAMOA]: defineMessage({
    id: "country.samoa",
    defaultMessage: "Samoa",
  }),
  [COUNTRY_CODES.SAN_MARINO]: defineMessage({
    id: "country.sanMarino",
    defaultMessage: "San Marino",
  }),
  [COUNTRY_CODES.SAO_TOME_AND_PRINCIPE]: defineMessage({
    id: "country.saoTomeAndPrincipe",
    defaultMessage: "Sao Tome and Principe",
  }),
  [COUNTRY_CODES.SAUDI_ARABIA]: defineMessage({
    id: "country.saudiArabia",
    defaultMessage: "Saudi Arabia",
  }),
  [COUNTRY_CODES.SENEGAL]: defineMessage({
    id: "country.senegal",
    defaultMessage: "Senegal",
  }),
  [COUNTRY_CODES.SERBIA_AND_MONTENEGRO]: defineMessage({
    id: "country.serbiaAndMontenegro",
    defaultMessage: "Serbia and Montenegro",
  }),
  [COUNTRY_CODES.SEYCHELLES]: defineMessage({
    id: "country.seychelles",
    defaultMessage: "Seychelles",
  }),
  [COUNTRY_CODES.SIERRA_LEONE]: defineMessage({
    id: "country.sierraLeone",
    defaultMessage: "Sierra Leone",
  }),
  [COUNTRY_CODES.SINGAPORE]: defineMessage({
    id: "country.singapore",
    defaultMessage: "Singapore",
  }),
  [COUNTRY_CODES.SLOVAKIA]: defineMessage({
    id: "country.slovakia",
    defaultMessage: "Slovakia",
  }),
  [COUNTRY_CODES.SLOVENIA]: defineMessage({
    id: "country.slovenia",
    defaultMessage: "Slovenia",
  }),
  [COUNTRY_CODES.SOLOMON_ISLANDS]: defineMessage({
    id: "country.solomonIslands",
    defaultMessage: "Solomon Islands",
  }),
  [COUNTRY_CODES.SOUTH_AFRICA]: defineMessage({
    id: "country.southAfrica",
    defaultMessage: "South Africa",
  }),
  [COUNTRY_CODES.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS]: defineMessage({
    id: "country.southGeorgia",
    defaultMessage: "South Georgia and the South Sandwich Islands",
  }),
  [COUNTRY_CODES.SPAIN]: defineMessage({
    id: "country.spain",
    defaultMessage: "Spain",
  }),
  [COUNTRY_CODES.SRI_LANKA]: defineMessage({
    id: "country.srilanka",
    defaultMessage: "Sri Lanka",
  }),
  [COUNTRY_CODES.SUDAN]: defineMessage({
    id: "country.sudan",
    defaultMessage: "Sudan",
  }),
  [COUNTRY_CODES.SURINAME]: defineMessage({
    id: "country.suriname",
    defaultMessage: "SuridefaultMessage",
  }),
  [COUNTRY_CODES.SVALBARD_AND_JAN_MAYEN]: defineMessage({
    id: "country.svalbard",
    defaultMessage: "Svalbard and Jan Mayen",
  }),
  [COUNTRY_CODES.SWAZILAND]: defineMessage({
    id: "country.swaziland",
    defaultMessage: "Swaziland",
  }),
  [COUNTRY_CODES.SWEDEN]: defineMessage({
    id: "country.sweden",
    defaultMessage: "Sweden",
  }),
  [COUNTRY_CODES.SWITZERLAND]: defineMessage({
    id: "country.switzerland",
    defaultMessage: "Switzerland",
  }),
  [COUNTRY_CODES.TAIWAN]: defineMessage({
    id: "country.taiwan",
    defaultMessage: "Taiwan, Province of China",
  }),
  [COUNTRY_CODES.TAJIKISTAN]: defineMessage({
    id: "country.tajikistan",
    defaultMessage: "Tajikistan",
  }),
  [COUNTRY_CODES.TANZANIA]: defineMessage({
    id: "country.tanzania",
    defaultMessage: "Tanzania",
  }),
  [COUNTRY_CODES.THAILAND]: defineMessage({
    id: "country.thailand",
    defaultMessage: "Thailand",
  }),
  [COUNTRY_CODES.TIMOR_LESTE]: defineMessage({
    id: "country.timor-Leste",
    defaultMessage: "Timor-Leste",
  }),
  [COUNTRY_CODES.TOGO]: defineMessage({
    id: "country.togo",
    defaultMessage: "Togo",
  }),
  [COUNTRY_CODES.TOKELAU]: defineMessage({
    id: "country.tokelau",
    defaultMessage: "Tokelau",
  }),
  [COUNTRY_CODES.TONGA]: defineMessage({
    id: "country.tonga",
    defaultMessage: "Tonga",
  }),
  [COUNTRY_CODES.TRINIDAD_AND_TOBAGO]: defineMessage({
    id: "country.trinidadAndTobago",
    defaultMessage: "Trinidad and Tobago",
  }),
  [COUNTRY_CODES.TUNISIA]: defineMessage({
    id: "country.tunisia",
    defaultMessage: "Tunisia",
  }),
  [COUNTRY_CODES.TURKEY]: defineMessage({
    id: "country.turkey",
    defaultMessage: "Turkey",
  }),
  [COUNTRY_CODES.TURKMENISTAN]: defineMessage({
    id: "country.turkmenistan",
    defaultMessage: "Turkmenistan",
  }),
  [COUNTRY_CODES.TCI]: defineMessage({
    id: "country.turksAndCaicosIslands",
    defaultMessage: "Turks and Caicos Islands",
  }),
  [COUNTRY_CODES.TUVALU]: defineMessage({
    id: "country.tuvalu",
    defaultMessage: "Tuvalu",
  }),
  [COUNTRY_CODES.UGANDA]: defineMessage({
    id: "country.uganda",
    defaultMessage: "Uganda",
  }),
  [COUNTRY_CODES.UKRAINE]: defineMessage({
    id: "country.ukraine",
    defaultMessage: "Ukraine",
  }),
  [COUNTRY_CODES.UAE]: defineMessage({
    id: "country.unitedArabEmirates",
    defaultMessage: "United Arab Emirates",
  }),
  [COUNTRY_CODES.US]: defineMessage({
    id: "country.us",
    defaultMessage: "United States",
  }),
  [COUNTRY_CODES.UM]: defineMessage({
    id: "country.unitedStatesMinorOutl",
    defaultMessage: "United States Minor Outlying Islands",
  }),
  [COUNTRY_CODES.URUGUAY]: defineMessage({
    id: "country.uruguay",
    defaultMessage: "Uruguay",
  }),
  [COUNTRY_CODES.UZBEKISTAN]: defineMessage({
    id: "country.uzbekistan",
    defaultMessage: "Uzbekistan",
  }),
  [COUNTRY_CODES.VANUATU]: defineMessage({
    id: "country.vanuatu",
    defaultMessage: "Vanuatu",
  }),
  [COUNTRY_CODES.VENEZUELA]: defineMessage({
    id: "country.venezuela",
    defaultMessage: "Venezuela",
  }),
  [COUNTRY_CODES.VIETNAM]: defineMessage({
    id: "country.vietnam",
    defaultMessage: "Vietnam",
  }),
  [COUNTRY_CODES.BVGI]: defineMessage({
    id: "country.britishVI",
    defaultMessage: "British Virgin Islands",
  }),
  [COUNTRY_CODES.USVI]: defineMessage({
    id: "country.USVI",
    defaultMessage: "U.S. Virgin Islands",
  }),
  [COUNTRY_CODES.WF]: defineMessage({
    id: "country.wallisAndFutuna",
    defaultMessage: "Wallis and Futuna",
  }),
  [COUNTRY_CODES.WSAHARA]: defineMessage({
    id: "country.westernSahara",
    defaultMessage: "Western Sahara",
  }),
  [COUNTRY_CODES.YEMEN]: defineMessage({
    id: "country.yemen",
    defaultMessage: "Yemen",
  }),
  [COUNTRY_CODES.ZAMBIA]: defineMessage({
    id: "country.zambia",
    defaultMessage: "Zambia",
  }),
  [COUNTRY_CODES.ZIMBABWE]: defineMessage({
    id: "country.zimbabwe",
    defaultMessage: "Zimbabwe",
  }),
  [COUNTRY_CODES.OTHER]: defineMessage({
    id: "country.other",
    defaultMessage: "Other",
  }),
};

const countryUnknownMessage = defineMessage({
  id: "country.unknown",
  defaultMessage: "Unknown",
});

const useCountryTranslation = () => {
  const { formatMessage } = useIntl();

  const translateCountryCode = React.useCallback(
    (countryCode: string) =>
      formatMessage(countryMap[countryCode] || countryUnknownMessage),
    [formatMessage],
  );

  const countries = React.useMemo(
    () =>
      sortBy(prop("name"))(
        Object.values(COUNTRY_CODES).map((code) => ({
          name: translateCountryCode(code),
          code,
        })),
      ),
    [translateCountryCode],
  );

  return { countries, translateCountryCode };
};

export default useCountryTranslation;
